<template>
  <footer class="bg-gray-900">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center p-2 flex-col sm:flex-row">
      <span class="sm:text-lg text-white sm:mr-2"
        >Поделиться:</span
      >
      <div class="flex">
        <ShareNetwork
          network="facebook"
          url="https://zarabotai.web.app/"
          title="Заработок на просмотрах видео."
          description="Честно про сайты для заработка на просмотрах видео, лайках, комментариях..."
          class="my-2 mx-2 sm:mx-3"
        >
          <icon name="facebook" width="24" height="24"></icon>
        </ShareNetwork>
        <ShareNetwork
          network="vk"
          url="https://zarabotai.web.app/"
          title="Заработок на просмотрах видео."
          description="Честно про сайты для заработка на просмотрах видео, лайках, комментариях..."
          class="my-2 mx-2 sm:mx-3"
        >
          <icon name="vk" width="24" height="24"></icon>
        </ShareNetwork>
        <ShareNetwork
          network="odnoklassniki"
          url="https://zarabotai.web.app/"
          title="Заработок на просмотрах видео."
          class="my-2 mx-2 sm:mx-3"
        >
          <icon name="odnoklassniki" width="24" height="24"></icon>
        </ShareNetwork>
        <ShareNetwork
          network="twitter"
          url="https://zarabotai.web.app/"
          title="Заработок на просмотрах видео."
          class="my-2 mx-2 sm:mx-3"
        >
          <icon name="twitter" width="24" height="24"></icon>
        </ShareNetwork>
        <ShareNetwork
          network="viber"
          url="https://zarabotai.web.app/"
          title="Заработок на просмотрах видео."
          description="Честно про сайты для заработка на просмотрах видео, лайках, комментариях..."
          class="my-2 mx-2 sm:mx-3"
        >
          <icon name="viber" width="24" height="24"></icon>
        </ShareNetwork>
        <ShareNetwork
          network="telegram"
          url="https://zarabotai.web.app/"
          title="Заработок на просмотрах видео."
          description="Честно про сайты для заработка на просмотрах видео, лайках, комментариях..."
          class="my-2 mx-2 sm:mx-3"
        >
          <icon name="telegram" width="24" height="24"></icon>
        </ShareNetwork>
        <ShareNetwork
          network="whatsapp"
          url="https://zarabotai.web.app/"
          title="Заработок на просмотрах видео."
          description="Честно про сайты для заработка на просмотрах видео, лайках, комментариях..."
          class="my-2 mx-2 sm:mx-3"
        >
          <icon name="whatsapp" width="24" height="24"></icon>
        </ShareNetwork>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "MyFooter",
  data() {
    return {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
